"use client";

import { ErrorState } from "@/components/error-state";

export default function GlobalErrorBoundary({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <ErrorState code="INTERNAL_SERVER_ERROR" onRetry={reset} reference={error.digest} />;
}
